// extracted by mini-css-extract-plugin
export default {"numberContainer":"PublishFlowItem_numberContainer__w1U+n","contentContainer":"PublishFlowItem_contentContainer__oE6an","flowItemContainer":"PublishFlowItem_flowItemContainer__36W9Y"};